import { Helper } from '../../Helper';
export class FindObjectPropertyHelperBase extends Helper {
    constructor({ whenHasProperty, whenNotHasProperty, getObject }) {
        super();
        this.whenHasProperty = whenHasProperty;
        this.whenNotHasProperty = whenNotHasProperty;
        this.getObject = getObject;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        const prepareLoop = () => {
            sb.emitOp(node, 'DUP');
            sb.emitHelper(node, options, sb.helpers.getPropertyObject);
            sb.emitOp(node, 'DUP');
            sb.emitOp(node, 'ROT');
            sb.emitHelper(node, options, this.getObject(sb));
            sb.emitOp(node, 'DUP');
            sb.emitPushInt(node, 4);
            sb.emitOp(node, 'PICK');
        };
        prepareLoop();
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'HASKEY');
                sb.emitOp(node, 'NOT');
                sb.emitOp(node, 'ROT');
                sb.emitPushString(node, '__proto__');
                sb.emitOp(node, 'HASKEY');
                sb.emitOp(node, 'BOOLAND');
            },
            each: () => {
                sb.emitOp(node, 'DROP');
                sb.emitPushString(node, '__proto__');
                sb.emitOp(node, 'PICKITEM');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'PICKITEM');
                prepareLoop();
            },
            cleanup: () => {
            },
        }));
        sb.emitOp(node, 'NIP');
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'HASKEY');
            },
            whenTrue: () => {
                this.whenHasProperty();
            },
            whenFalse: () => {
                this.whenNotHasProperty();
            },
        }));
    }
}

//# sourceMappingURL=FindObjectPropertyHelperBase.js.map
